
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ikoZN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4c08cbcf9dcf3e2f$export$2e2bcd8739ae039);

var $c3WQb = parcelRequire("c3WQb");

var $lv9xW = parcelRequire("lv9xW");

var $4Te8c = parcelRequire("4Te8c");
/**
 * Cleanups the cache when the resource key change or unmount.
 * This way of invalidation is not available yet on the react-resource-router
 */ const $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidate = ()=>{
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsReduxStoreStateResource));
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsPlanPageInitialChecksResource));
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsPlanReportPageInitialChecksResource));
    (0, $4Te8c.useResourceInvalidate)((0, $lv9xW.advancedRoadmapsSummaryDataResource));
    (0, $4Te8c.useResourceInvalidate)((0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource));
    return null;
};
var $4c08cbcf9dcf3e2f$export$2e2bcd8739ae039 = $4c08cbcf9dcf3e2f$var$PlanResourcesInvalidate;

});
parcelRegister("4Te8c", function(module, exports) {

$parcel$export(module.exports, "useResourceInvalidate", () => $b78a1b8a11e72a7e$export$b53e28d71b4855d0);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");
const $b78a1b8a11e72a7e$export$b53e28d71b4855d0 = (resource)=>{
    const { clear: clear, key: key } = (0, $2YP9W.useResource)(resource);
    (0, $5uXOq.useEffect)(()=>()=>{
            clear();
        }, [
        key,
        clear
    ]);
};

});



//# sourceMappingURL=async-plan-resources-invalidate.ecba5d9f.js.map
